import { jsx as _jsx } from "react/jsx-runtime";
import sprite from 'assets/images/createObject/sprite-object.svg';
export const ObjectIcon = ({ className, iconId, ariaHidden }) => (_jsx("svg", Object.assign({ className: className, "aria-hidden": ariaHidden }, { children: _jsx("use", { href: `${sprite}#${iconId}` }) })));
